import { useLoginState } from './useLoginState.js';

export function usePlatform() {
	const loginState = useLoginState();
	return loginState.platform;
}
